export default __webpack_public_path__ + "static/media/3bet_0003_thumb.672178eb.jpg";